// src/lib/contracts/format.js
// Formatting helpers used by every contract template.

const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

export function fmtMoney(n) {
  if (n === null || n === undefined || n === '') return '';
  const v = Number(n);
  if (!isFinite(v)) return '';
  return v.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}

export function fmtMoneyAmount(n) {
  // Just the digits with commas, no $ — for "$ ____" lines
  if (n === null || n === undefined || n === '') return '';
  const v = Number(n);
  if (!isFinite(v)) return '';
  return v.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

export function fmtDate(iso) {
  // "2026-05-15" → "May 15, 2026"
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${MONTHS[m - 1]} ${d}, ${y}`;
}

export function fmtDateOrdinal(iso) {
  // "2026-05-15" → "15th day of May, 2026"
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return iso;
  const ordinal = d => {
    const s = ['th','st','nd','rd'], v = d % 100;
    return d + (s[(v - 20) % 10] || s[v] || s[0]);
  };
  return `${ordinal(d)} day of ${MONTHS[m - 1]}, ${y}`;
}

// Short form "May 15, 2026" or today's date
export function todayLong() {
  const t = new Date();
  return `${MONTHS[t.getMonth()]} ${t.getDate()}, ${t.getFullYear()}`;
}

// Returns {day, month, year} as digit/word strings for assignment-style "this ___ day of ___ 20___"
export function dateParts(iso) {
  if (!iso) return { day: '', month: '', year: '' };
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return { day: '', month: '', year: '' };
  const yearShort = String(y).slice(-2);
  return { day: String(d), month: MONTHS[m - 1], year: yearShort, fullYear: String(y) };
}

// Inline blank: returns the value if present, otherwise an underline placeholder.
// Use this in the actual document body so "TBD" fields show as the classic legal "____".
export function blank(value, opts = {}) {
  const w = opts.width || 'auto';
  if (value !== null && value !== undefined && String(value).trim() !== '') {
    return `<span class="filled">${escapeHtml(String(value))}</span>`;
  }
  return `<span class="blank" style="min-width:${w};">&nbsp;</span>`;
}

export function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, ch => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[ch]));
}
